import { render, staticRenderFns } from "./TitleLink.vue?vue&type=template&id=2526ed3f&"
import script from "./TitleLink.vue?vue&type=script&lang=js&"
export * from "./TitleLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TitleLink.vue"
export default component.exports